import { render, staticRenderFns } from "./AdvertsDetails.vue?vue&type=template&id=be14aef8&"
import script from "./AdvertsDetails.vue?vue&type=script&lang=js&"
export * from "./AdvertsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports